"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayBoxHtml = void 0;
require("./indexGrid.scss");
var im = require("./image-defaults/imageNone.jpg");
var DisplayBoxHtml = /** @class */ (function () {
    function DisplayBoxHtml() {
    }
    // Methode pour afficher les resultats de toutes les encadrés
    DisplayBoxHtml.prototype.displayResultBoxes = function (startIndex, resultBoxes, resultsEl, translations) {
        if (startIndex === void 0) { startIndex = 0; }
        // Affichage du nombre total de résultats obtenus
        if (startIndex === 0) {
            resultsEl.innerHTML = "";
            var resultCount = document.createElement("div");
            resultCount.className = "result-count";
            resultCount.textContent = "".concat(resultBoxes.length, " ").concat(translations["ObjectsInResult"]);
            resultsEl.appendChild(resultCount);
        }
        // Affichage des resultats par bloc de 100 resultats
        var pageSize = 100;
        var endIndex = Math.min(startIndex + pageSize, resultBoxes.length);
        var gridContainer = document.createElement("div");
        gridContainer.className = "result-grid";
        // Parcourir le resultBoxes et créer un encadré pour chaque résultat
        for (var i = startIndex; i < endIndex; i++) {
            var resultBox = resultBoxes[i].image
                ? this.createResultBoxWithImage(resultBoxes[i], translations)
                : this.createResultBoxWithoutImage(resultBoxes[i], translations);
            gridContainer.appendChild(resultBox);
        }
        // Tracer un trait entre les anciens et les nouveaux résultats
        if (startIndex !== 0) {
            var separator = document.createElement("hr");
            separator.className = "result-separator";
            resultsEl.appendChild(separator);
        }
        resultsEl.appendChild(gridContainer);
        // Ajouter le bouton "load more" à chaque fin de la page
        if (endIndex < resultBoxes.length) {
            this.addLoadMoreButton(endIndex, resultBoxes, resultsEl, translations);
        }
        else {
            // Ajout du message de fin des résultats et du bouton retour au début
            var endMessage = document.createElement("div");
            endMessage.textContent = "".concat(translations["EndResults"]);
            endMessage.classList.add("end-message");
            var returnToTopButton = document.createElement("button");
            returnToTopButton.textContent = "".concat(translations["BackToTop"]);
            returnToTopButton.classList.add("return-to-top-button");
            returnToTopButton.addEventListener("click", function () {
                window.scrollTo(0, 0);
            });
            // Ajout des éléments au DOM
            resultsEl.appendChild(endMessage);
            resultsEl.appendChild(returnToTopButton);
        }
        this.initializeClickEvents();
    };
    // Methode pour ajouter le bouton load more
    DisplayBoxHtml.prototype.addLoadMoreButton = function (endIndex, resultBoxes, resultsEl, translations) {
        var _this = this;
        var loadMoreButton = document.createElement("button");
        loadMoreButton.textContent = "".concat(translations["LoadMore"]);
        loadMoreButton.className = "load-more-button";
        loadMoreButton.addEventListener("click", function () {
            var startIndex = endIndex;
            _this.displayResultBoxes(startIndex, resultBoxes, resultsEl, translations);
            loadMoreButton.remove();
        });
        resultsEl.appendChild(loadMoreButton);
    };
    //methode qui gere l'affichage des encadrés avec image
    //cette methode permet de creer un encadré pour chaque resultat qui contient une image
    //PS : travailler sur les conditions pour afficher les resultats sans probleme et sans doublon "gerer tout les cas possibles"
    DisplayBoxHtml.prototype.createResultBoxWithImage = function (resultBox, translations) {
        var _this = this;
        var resultBoxElement = document.createElement("div");
        resultBoxElement.className = "result-box";
        // Un div qui contient l'image et le type de document
        var containerImageType = document.createElement("div");
        containerImageType.className = "container-image-type";
        // Un div qui contient le type de document (icône + label)
        var documentTypeContainer = document.createElement("div");
        documentTypeContainer.className = "document-type-container";
        var documentTypeLabel = document.createElement("div");
        documentTypeLabel.className = "document-type-label";
        // build the icon HTML
        var iconHtml = "";
        if (resultBox.typeResultBox.icon &&
            resultBox.typeResultBox.icon.startsWith("<")) {
            // old Sparnatural : icon is returned with outer span
            iconHtml = resultBox.typeResultBox.icon;
        }
        else if (resultBox.typeResultBox.icon) {
            // new Sparnatural : icon is returned with just the code
            iconHtml = "<i style=\"font-size:180%\" class=\"".concat(resultBox.typeResultBox.icon, "\"></i>&nbsp;");
        }
        documentTypeLabel.innerHTML = "".concat(iconHtml, "<strong>").concat(resultBox.typeResultBox.label, "</strong>");
        documentTypeContainer.appendChild(documentTypeLabel);
        //ajouter le type de document au container general
        containerImageType.appendChild(documentTypeContainer);
        // Div pour l'image
        var imageContainer = document.createElement("div");
        imageContainer.className = "image-container";
        var photoElement = document.createElement("img");
        photoElement.src = resultBox.image || im;
        photoElement.alt = "Image indisponible";
        // Ajout d'un gestionnaire d'erreurs pour charger l'image de secours si la première image échoue
        photoElement.onerror = function () {
            console.log("Image loading failed");
            this.onerror = null; // Évite une boucle d'erreurs si l'image de secours échoue également
            this.src = im;
        };
        imageContainer.appendChild(photoElement);
        // Ajouter le bouton "Consulter" ici
        var consultButtonContainer = document.createElement("div");
        consultButtonContainer.className = "consult-button-container";
        var consultButton = document.createElement("button");
        consultButton.textContent = "".concat(translations["Consult"]);
        consultButton.addEventListener("click", function () {
            window.open(resultBox.uri, "_blank");
        });
        consultButtonContainer.appendChild(consultButton);
        imageContainer.appendChild(consultButtonContainer); // Ajout du bouton au conteneur d'image
        // Ajouter l'image au conteneur général
        containerImageType.appendChild(imageContainer);
        resultBoxElement.appendChild(containerImageType);
        // Div pour le titre de l'encadré
        var titleElement = document.createElement("div");
        titleElement.className = "main-title";
        titleElement.innerHTML = "<strong>".concat(this.limitTitleLength(resultBox.title, 50), "</strong>");
        var key = document.createElement("div");
        key.className = "key";
        key.appendChild(titleElement);
        resultBoxElement.appendChild(key);
        // Div pour les propriétés de l'encadré (scrollable)
        var scrollableContainer = document.createElement("div");
        scrollableContainer.className = "scrollable-container";
        //PS : travailler sur les conditions pour afficher les resultats sans problemes et sans doublons
        resultBox.predicates.forEach(function (property) {
            var keyValueElementCreated = false;
            property.values.forEach(function (value) {
                if (value.label !== "") {
                    if (value.predicates.length > 0) {
                        var keyValueElement_1 = document.createElement("div");
                        keyValueElement_1.className = "key-value-element";
                        if (value.label !== resultBox.title) {
                            if (value.uri !== "") {
                                keyValueElement_1.innerHTML = "<li/>".concat(property.label, " : <a href=\"").concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a> <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                            }
                            else if (value.label !== "") {
                                var val = value.label || "";
                                keyValueElement_1.innerHTML = "<li/>".concat(property.label, " : ").concat(_this.limitLength(val, 150, translations));
                            }
                            else if (value.predicates.length > 0) {
                                // keyValueElement.innerHTML = `<li/>${property.label} : <span class="objet">(${property.valueType.label})</span>`;
                                // Thomas 2024-10-17 : avoid printing the valueType label if there is no actual value
                                keyValueElement_1.innerHTML = "<li/>".concat(property.label, " : ");
                            }
                        }
                        else if (value.predicates.length > 0) {
                            keyValueElement_1.innerHTML = "<li/>".concat(property.label, " <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                        }
                        if (value.predicates && value.predicates.length > 0) {
                            value.predicates.forEach(function (child) {
                                var childElement = _this.createResultBoxFromProperty(child, resultBox, translations);
                                keyValueElement_1.appendChild(childElement);
                            });
                        }
                        scrollableContainer.appendChild(keyValueElement_1);
                        keyValueElementCreated = true;
                    }
                }
                else {
                    if (value.label === "" && value.predicates.length > 0) {
                        var keyValueElement_2 = document.createElement("div");
                        keyValueElement_2.className = "key-value-element";
                        if (value.label !== resultBox.title) {
                            if (value.uri !== "") {
                                keyValueElement_2.innerHTML = "<li/>".concat(property.label, " : <a href=\"").concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a> <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                            }
                            else if (value.label !== "") {
                                var val = value.label || "";
                                keyValueElement_2.innerHTML = "<li/>".concat(property.label, " : ").concat(_this.limitLength(val, 150, translations));
                            }
                            else if (value.predicates.length > 0 &&
                                value.predicates.find(function (predicate) {
                                    return predicate.values.find(function (value) { return value.label !== ""; });
                                })) {
                                // keyValueElement.innerHTML = `<li/>${property.label} : <span class="objet">(${property.valueType.label})</span>`;
                                // Thomas 2024-10-17 : avoid printing the valueType label if there is no actual value
                                keyValueElement_2.innerHTML = "<li/>".concat(property.label, " : ");
                            }
                        }
                        else if (value.predicates.length > 0) {
                            // keyValueElement.innerHTML = `<li/>${property.label} <span class="objet">(${property.valueType.label})</span>`;
                            // Thomas 2024-10-17 : avoid printing the valueType label if there is no actual value
                            keyValueElement_2.innerHTML = "<li/>".concat(property.label, " ");
                        }
                        if (value.predicates && value.predicates.length > 0) {
                            value.predicates.forEach(function (child) {
                                var childElement = _this.createResultBoxFromProperty(child, resultBox, translations);
                                keyValueElement_2.appendChild(childElement);
                            });
                        }
                        scrollableContainer.appendChild(keyValueElement_2);
                        keyValueElementCreated = true;
                    }
                }
            });
            if (!keyValueElementCreated && property.values.length > 0) {
                var valuesList = property.values
                    .map(function (value) {
                    if (value.uri && value.id) {
                        return "<a href=\"".concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a>");
                    }
                    else {
                        return "".concat(_this.limitLength(value.label || "", 150, translations));
                    }
                })
                    .join(", ");
                var keyValueElement = document.createElement("div");
                keyValueElement.className = "key-value-element";
                for (var i = 0; i < property.values.length; i++) {
                    if (property.values[i].uri !== "" &&
                        property.values[i].label !== "") {
                        keyValueElement.innerHTML = "<li/>".concat(property.label, " : ").concat(valuesList, " <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                    }
                    else {
                        if (property.values[i].label !== "") {
                            keyValueElement.innerHTML = "<li/>".concat(property.label, " : ").concat(valuesList);
                        }
                    }
                    scrollableContainer.appendChild(keyValueElement);
                }
            }
            key.appendChild(scrollableContainer);
        });
        resultBoxElement.appendChild(key);
        return resultBoxElement;
    };
    //methode qui gere l'affichage des enfants des resultats
    // recursive function
    // PS : travailler sur les conditions pour afficher les resultats sans probleme et sans doublon "gerer tout les cas possibles"
    DisplayBoxHtml.prototype.createResultBoxFromProperty = function (property, resultBox, translations) {
        var _this = this;
        var resultBoxElement = document.createElement("div");
        resultBoxElement.className = "result-box-child";
        var keyValueElement = document.createElement("div");
        keyValueElement.className = "key-value-element-child";
        /*  // Fonction utilitaire pour filtrer les doublons
        const uniqueValues = (values) => {
          const seen = new Set();
          return values.filter((value) => {
            const duplicate = seen.has(value.label);
            seen.add(value.label);
            return !duplicate;
          });
        };*/
        // Fonction utilitaire pour filtrer les doublons
        var uniqueValues = function (values) {
            var seen = new Set();
            return values.filter(function (value) {
                var duplicate = seen.has(value.id);
                seen.add(value.id);
                return !duplicate;
            });
        };
        // Filtrer les valeurs en doublon
        var filteredValues = uniqueValues(property.values);
        // Mapping des valeurs
        var valuesList = filteredValues
            .map(function (value) {
            if (value.uri && value.label) {
                return "<a href=\"".concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a>");
            }
            else {
                return "".concat(_this.limitLength(value.label || "", 150, translations));
            }
        })
            .join(", ");
        // Conditions spécifiques
        var valueAppended = false;
        for (var i = 0; i < filteredValues.length; i++) {
            var value = filteredValues[i];
            if (value.label !== resultBox.title) {
                if (value.uri !== "" && value.label !== "") {
                    keyValueElement.innerHTML = "<li/>".concat(property.label, " : ").concat(valuesList, " <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                    resultBoxElement.appendChild(keyValueElement);
                    valueAppended = true;
                    break;
                }
                else if (value.label !== "") {
                    keyValueElement.innerHTML = "<li/>".concat(property.label, " : ").concat(this.limitLength(value.label, 150, translations));
                    resultBoxElement.appendChild(keyValueElement);
                    valueAppended = true;
                    break;
                }
                else if (value.predicates.find(function (predicate) {
                    return predicate.values.find(function (value) { return value.label !== ""; });
                })) {
                    // keyValueElement.innerHTML = `<li/>${property.label} : <span class="objet">(${property.valueType.label})</span>`;
                    // Thomas 2024-10-17 : avoid printing the valueType label if there is no actual value
                    keyValueElement.innerHTML = "<li/>".concat(property.label, " : ");
                    resultBoxElement.appendChild(keyValueElement);
                    valueAppended = true;
                    break;
                }
                else if (!this.isImageURI(value.uri)) {
                    keyValueElement.innerHTML = "<li/>".concat(property.label, " : ").concat(value.uri, " <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                    resultBoxElement.appendChild(keyValueElement);
                    valueAppended = true;
                    break;
                }
            }
        }
        //filter les valeurs a chaque fois qu'il y a un doublon
        if (!valueAppended && filteredValues.find(function (value) { return value.id !== ""; })) {
            // keyValueElement.innerHTML = `<li/>${property.label} : <span class="objet">(${property.valueType.label})</span>`;
            // Thomas 2024-10-17 : avoid printing the valueType label if there is no actual value
            keyValueElement.innerHTML = "<li/>".concat(property.label, " : ");
            resultBoxElement.appendChild(keyValueElement);
        }
        else if (!valueAppended) {
            keyValueElement.innerHTML = "";
            resultBoxElement.appendChild(keyValueElement);
        }
        // Ajout des children si existent
        filteredValues.forEach(function (value) {
            if (value.predicates && value.predicates.length > 0) {
                value.predicates.forEach(function (child) {
                    var childElement = _this.createResultBoxFromProperty(child, resultBox, translations);
                    keyValueElement.appendChild(childElement);
                });
            }
        });
        return resultBoxElement;
    };
    //cette methode permet de verifier si l'uri est une image
    //avec une expression reguliere "all urls that containing words as '.jpg, .jpeg, .png, .svg ' we can add more extensions if needed"
    DisplayBoxHtml.prototype.isImageURI = function (uri) {
        //we can add more extensions if needed just add  '|.extension'
        return uri.match(/\.(jpg|jpeg|png|svg)(\?.*)?$/i) !== null;
    };
    DisplayBoxHtml.prototype.createResultBoxWithoutImage = function (resultBox, translations) {
        var _this = this;
        var resultBoxElement = document.createElement("div");
        resultBoxElement.className = "result-box";
        var key = document.createElement("div");
        key.className = "key-wo-image";
        var documentTypeContainer = document.createElement("div");
        documentTypeContainer.className = "document-type-container-wo-image";
        var documentTypeLabel = document.createElement("div");
        documentTypeLabel.className = "document-type-label-wo-image";
        // build the icon HTML
        var iconHtml = "";
        if (resultBox.typeResultBox.icon &&
            resultBox.typeResultBox.icon.startsWith("<")) {
            // old Sparnatural : icon is returned with outer span
            iconHtml = resultBox.typeResultBox.icon;
        }
        else if (resultBox.typeResultBox.icon) {
            // new Sparnatural : icon is returned with just the code
            iconHtml = "<i style=\"font-size:180%\" class=\"".concat(resultBox.typeResultBox.icon, "\"></i>");
        }
        if (iconHtml) {
            documentTypeLabel.innerHTML = "".concat(iconHtml);
        }
        else {
            documentTypeLabel.innerHTML = "<strong>".concat(resultBox.typeResultBox.label, "</strong>");
        }
        var titleElement = document.createElement("div");
        titleElement.className = "main-title-wo-image";
        titleElement.innerHTML = "<a href=\"".concat(resultBox.uri, "\" target=\"_blank\"><strong>").concat(this.limitTitleLength(resultBox.title, 50), "</strong></a>");
        documentTypeContainer.appendChild(documentTypeLabel);
        documentTypeContainer.appendChild(titleElement);
        key.appendChild(documentTypeContainer);
        resultBoxElement.appendChild(key);
        var scrollableContainer = document.createElement("div");
        scrollableContainer.className = "scrollable-container-wo-image";
        resultBox.predicates.forEach(function (property) {
            var keyValueElementCreated = false;
            console.log(property.label);
            property.values.forEach(function (value) {
                if (value.label !== "") {
                    if (value.predicates.length > 0) {
                        var keyValueElement_3 = document.createElement("div");
                        keyValueElement_3.className = "key-value-element";
                        if (value.label !== resultBox.title) {
                            if (value.uri !== "") {
                                keyValueElement_3.innerHTML = "<li/>".concat(property.label, " : <a href=\"").concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a> <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                            }
                            else if (value.label !== "") {
                                var val = value.label || "";
                                keyValueElement_3.innerHTML = "<li/>".concat(property.label, " : ").concat(_this.limitLength(val, 150, translations), "cc");
                            }
                            else if (value.predicates.length > 0) {
                                // keyValueElement.innerHTML = `<li/>${property.label} : <span class="objet">(${property.valueType.label})</span>`;
                                // Thomas 2024-10-17 : avoid printing the valueType label if there is no actual value
                                keyValueElement_3.innerHTML = "<li/>".concat(property.label, " : ccc");
                            }
                        }
                        else if (value.predicates.length > 0) {
                            keyValueElement_3.innerHTML = "<li/>".concat(property.label, " <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                        }
                        if (value.predicates && value.predicates.length > 0) {
                            value.predicates.forEach(function (child) {
                                var childElement = _this.createResultBoxFromProperty(child, resultBox, translations);
                                keyValueElement_3.appendChild(childElement);
                            });
                        }
                        scrollableContainer.appendChild(keyValueElement_3);
                        keyValueElementCreated = true;
                    }
                }
                else {
                    if (value.label === "" && value.predicates.length > 0) {
                        var keyValueElement_4 = document.createElement("div");
                        keyValueElement_4.innerHTML = "<li/>".concat(property.label, " :");
                        keyValueElement_4.className = "key-value-element";
                        if (value.label !== resultBox.title) {
                            if (value.uri !== "") {
                                keyValueElement_4.innerHTML = "<li/>".concat(property.label, " : <a href=\"").concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a> <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                            }
                            else if (value.label !== "") {
                                var val = value.label || "";
                                keyValueElement_4.innerHTML = "<li/>".concat(property.label, " : ").concat(_this.limitLength(val, 150, translations));
                            }
                            else if (value.predicates.length > 0 &&
                                value.predicates.find(function (predicate) {
                                    return predicate.values.find(function (value) { return value.label !== ""; });
                                })) {
                                // keyValueElement.innerHTML = `<li/>${property.label} : <span class="objet">(${property.valueType.label})</span>`;
                                // Thomas 2024-10-17 : avoid printing the valueType label if there is no actual value
                                keyValueElement_4.innerHTML = "<li/>".concat(property.label, " : ");
                            }
                        }
                        else if (value.predicates.length > 0) {
                            // keyValueElement.innerHTML = `<li/>${property.label} <span class="objet">(${property.valueType.label})</span>`;
                            // Thomas 2024-10-17 : avoid printing the valueType label if there is no actual value
                            keyValueElement_4.innerHTML = "<li/>".concat(property.label);
                        }
                        if (value.predicates && value.predicates.length > 0) {
                            value.predicates.forEach(function (child) {
                                var childElement = _this.createResultBoxFromProperty(child, resultBox, translations);
                                keyValueElement_4.appendChild(childElement);
                            });
                        }
                        scrollableContainer.appendChild(keyValueElement_4);
                        keyValueElementCreated = true;
                    }
                }
            });
            if (!keyValueElementCreated && property.values.length > 0) {
                var valuesList = property.values
                    .map(function (value) {
                    if (value.uri && value.label) {
                        return "<a href=\"".concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a>");
                    }
                    else {
                        return "".concat(_this.limitLength(value.label || "", 150, translations));
                    }
                })
                    .join(", ");
                var keyValueElement = document.createElement("div");
                keyValueElement.className = "key-value-element";
                for (var i = 0; i < property.values.length; i++) {
                    if (property.values[i].uri !== "" &&
                        property.values[i].label !== "") {
                        keyValueElement.innerHTML = "<li/>".concat(property.label, " : ").concat(valuesList, " <span class=\"objet\">(").concat(property.valueType.label, ")</span>");
                    }
                    else {
                        if (property.values[i].label !== "") {
                            keyValueElement.innerHTML = "<li/>".concat(property.label, " : ").concat(valuesList);
                        }
                    }
                    scrollableContainer.appendChild(keyValueElement);
                }
            }
            key.appendChild(scrollableContainer);
        });
        resultBoxElement.appendChild(key);
        return resultBoxElement;
    };
    //cette methode permet de limiter la longueur du titre de l'encadré
    //si le titre est superieur à 50 caractères, on affiche les 50 premiers caractères
    //avec l'option de popup pour afficher le titre complet si on passe la souris sur le titre
    DisplayBoxHtml.prototype.limitTitleLength = function (title, maxLength) {
        if ((title !== null && title !== void 0 ? title : "").length > maxLength) {
            var truncatedTitle = (title !== null && title !== void 0 ? title : "").slice(0, maxLength) + "(...)";
            var truncatedElement = "<span class=\"truncated-title\" title=\"".concat(title, "\" style=\"color:black;\">").concat(truncatedTitle, "</span>");
            return truncatedElement;
        }
        return title !== null && title !== void 0 ? title : "";
    };
    // cette methode permet de limiter la longueur du texte
    // si on clique sur "lire la suite", on affiche le texte complet
    //cette methode permet de laisser l'encadré lisible et de ne pas surcharger l'interface
    DisplayBoxHtml.prototype.limitLength = function (text, maxLength, translations) {
        if ((text !== null && text !== void 0 ? text : "").length > maxLength) {
            var truncatedTitle = (text !== null && text !== void 0 ? text : "").slice(0, maxLength);
            var remainingTitle = (text !== null && text !== void 0 ? text : "").slice(maxLength);
            var truncatedElement = "\n            <span class=\"\" title=\"".concat(text, "\">\n                ").concat(truncatedTitle, "<a class=\"show-more\">").concat(translations["more"], "</a><span class=\"remaining-title\" style=\"display: none;\">").concat(remainingTitle, "</span>\n            </span>");
            return truncatedElement;
        }
        return "<span class=\"property-text\">".concat(text !== null && text !== void 0 ? text : "", "</span>");
    };
    //cette methode permet d'initialiser les evenements click
    //prend la class "show-more" et affiche le texte complet
    //eventListener
    DisplayBoxHtml.prototype.initializeClickEvents = function () {
        var showMoreElements = document.querySelectorAll(".show-more");
        showMoreElements.forEach(function (element) {
            element.addEventListener("click", function (event) {
                var target = event.target;
                var remainingTextElement = target.nextElementSibling;
                if (remainingTextElement) {
                    remainingTextElement.style.display = "inline";
                    target.style.display = "none";
                }
            });
        });
    };
    return DisplayBoxHtml;
}());
exports.DisplayBoxHtml = DisplayBoxHtml;
